'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ThemeDetailsResponse from 'ecosystem-marketplace-core/records/ThemeDetailsResponse';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { getAppShortlink } from 'ecosystem-marketplace-core/assets/utils/urls';
import { getThemeDetailsPreview } from '../clients/ecosystemClient';
import ThemeDetailsPage from '../components/details/ThemeDetailsPage';
import NotFoundError from '../components/error/NotFoundError';
import GenericError from '../components/error/GenericError';
import UsageTrackerContext from '../context/UsageTrackerContext';

const ThemeDetailsPreviewContainer = () => {
  const {
    slug
  } = useParams();
  const [requestError, setRequestError] = useState(null);
  const [requestState, setRequestState] = useState(RequestStates.UNINITIALIZED);
  const [themeDetails, setThemeDetailsResponse] = useState(null);
  useEffect(() => {
    if (requestState === RequestStates.UNINITIALIZED) {
      setRequestState(RequestStates.PENDING);
      getThemeDetailsPreview(slug).then(resp => {
        setThemeDetailsResponse(new ThemeDetailsResponse(resp));
        setRequestError(null);
        setRequestState(RequestStates.SUCCEEDED);
      }).catch(error => {
        setRequestError(error);
        setThemeDetailsResponse(null);
        setRequestState(RequestStates.FAILED);
      });
    }
  }, [requestState, slug]);

  if (requestError) {
    if (requestError.status === 403) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "THEME_DETAILS_FORBIDDEN_ERROR_LOAD",
        children: /*#__PURE__*/_jsx(UIErrorMessage, {
          illustration: "keys",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.themes.details.previewForbiddenError.title"
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            className: "m-top-4",
            href: getAppShortlink({
              pathname: `/themes/_preview/${slug}`
            }, false),
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.themes.details.previewForbiddenError.buttonText"
            })
          })
        })
      });
    } else if (requestError.status === 404) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "THEME_DETAILS_404_LOAD",
        children: /*#__PURE__*/_jsx(NotFoundError, {})
      });
    } else {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "THEME_DETAILS_ERROR_LOAD",
        children: /*#__PURE__*/_jsx(GenericError, {})
      });
    }
  }

  if (requestState !== RequestStates.SUCCEEDED) {
    return null;
  }

  return /*#__PURE__*/_jsxs(UsageTrackerContext.Provider, {
    value: {
      screen: 'theme details preview'
    },
    children: [/*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.previewAlert.title"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.previewAlert.message"
      })
    }), /*#__PURE__*/_jsx(ThemeDetailsPage, {
      themeDetails: themeDetails,
      use: "preview"
    })]
  });
};

export default ThemeDetailsPreviewContainer;